import { render, staticRenderFns } from "./CamaCxc.vue?vue&type=template&id=b74d7742"
import script from "./CamaCxc.vue?vue&type=script&lang=js"
export * from "./CamaCxc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports